$(document).on('turbolinks:load', function() {
  
  $('.video-container').on('click', '.remove-content-video', function(e) {
    e.preventDefault();
    if(confirm('Are you sure you want to delete this content?')) {
      let reason = $(this).closest('.remove-reason-overlay').find('textarea').val();
      $.ajax({
        url: '/pitches/remove_content',
        type: 'POST',
        data: {
          'id': $("#pitch_id").val(),
          'student_id': $("#pitch_student_id").val(),
          'type': 'pitch',
          'reason': reason,
        }
      });
    }
  });

  $('.video-container').on('click', '.remove-content-final-video', function(e) {
    e.preventDefault();
    if(confirm('Are you sure you want to delete this content?')) {
      $.ajax({
        url: '/pitches/remove_widdy_content',
        type: 'POST',
        data: {
          'id': $("#final_pitch_video_id").val(),
          'student_id': $("#final_pitch_video_student_id").val()
        }
      });
    }
  });

  setTimeout(function() {
    media = document.querySelector('video');
    if (media != null && media.readyState < 3) {
      src = $('video').attr('src');
      type = $('video').attr('type');
      $('video').append('<source src="' + src + '" type="' + type + '" />');
      $('video').removeAttr('src');
      $('video').removeAttr('type');
      $('video')[0].load();
    }
  }, 3000);
});
